// ─── QUERY KEY FACTORY ────────────────────────────────────────────────────────
// Centralised, normalised keys prevent object-identity cache misses.
// Always use primitives in key arrays — never pass raw objects.

export const queryKeys = {
  admin: {
    // Orders ──────────────────────────────────────────────────────────────────
    // Scoped key for a specific page/status/limit combination
    orders: ({ page, limit, status }) => ['orders', page, limit, status],

    // Root key for invalidation — invalidates ALL orders queries regardless of params
    ordersRoot: () => ['orders'],

    // Applications ────────────────────────────────────────────────────────────
    // Scoped key by status filter
    applications: ({ status }) => ['applications', status],

    // Root key for invalidation — invalidates ALL applications queries
    applicationsRoot: () => ['applications'],

    // Products ────────────────────────────────────────────────────────────────
    // Single key (no pagination needed — full table is small)
    products: () => ['products'],
    productsRoot: () => ['products'],

    // Customers ───────────────────────────────────────────────────────────────
    customers: () => ['customers'],
    customersRoot: () => ['customers'],

    // Vendors ─────────────────────────────────────────────────────────────────
    vendors: () => ['vendors'],
    vendorsRoot: () => ['vendors'],
    vendorPendingProducts: () => ['vendor-pending-products'],

    // Retailer contacts (people at a customer account) ────────────────────────
    // Scoped per account; root invalidates every account's list.
    retailerContacts: (accountId) => ['retailer-contacts', accountId],
    retailerContactsRoot: () => ['retailer-contacts'],
    // Every contact in one list — the Orders screen resolves comms recipients
    // from this. Shares the root prefix, so promoting/deactivating a contact
    // invalidates it automatically.
    retailerContactsAll: () => ['retailer-contacts', 'all'],

    // CRM row → catalogue token lookup (email/phone match, one query per screen)
    customerTokenIndex: () => ['customer-token-index'],
  },

  vendor: {
    // The signed-in vendor's own data (vendor portal)
    me: () => ['vendor-me'],
    myProducts: (vendorId) => ['vendor-products', vendorId],
    myProductsRoot: () => ['vendor-products'],
  },
};
